import { connect } from 'react-redux';
import Users from './transactions';

export default connect()(Users);
